// array of books that I have read

const pastBooks = [
  {
    id: 1,
    title: "Aion",
    author: "Carl Jung",
    date: "2021",
    rating: "10",
    topic: "Psychology",
  },
  {
    id: 2,
    title: "Transcend",
    author: "Scott Barry Kaufman",
    date: "2021",
    rating: "7",
    topic: "Psychology",
  },
  {
    id: 3,
    title: "JavaScript The Definitive Guide",
    author: "David Flanagan",
    date: "2021",
    rating: "7",
    topic: "Language Textbook",
  },
  {
    id: 4,
    title: "Psychology and Alchemy",
    author: "Carl Jung",
    date: "2021",
    rating: "10",
    topic: "Psychology",
  },

  {
    id: 5,
    title: "The Outline of History",
    author: "H.G. Wells",
    date: "2020",
    rating: "7",
    topic: "History",
  },
  {
    id: 6,
    title: "All The Light We Cannot See",
    author: "Anthony Doerr",
    date: "2020",
    rating: "9",
    topic: "Historical Fiction",
  },
  {
    id: 7,
    title: "The Iliad",
    author: "Homer",
    date: "2021",
    rating: "7",
    topic: "Classics",
  },
  {
    id: 8,
    title: "Toward a psychology of being",
    author: "Abraham Maslow",
    date: "2020",
    rating: "8",
    topic: "Psychology",
  },
  {
    id: 9,
    title:
      "Emotional Awareness - conversation between Dalai Lama and Paul Ekman",
    author: "Paul Ekman",
    date: "2021",
    rating: "7",
    topic: "Psychology",
  },
  {
    id: 10,
    title: "Benjamin Franklin",
    author: "Walter Isaacson",
    date: "2020",
    rating: "8",
    topic: "History",
  },

  {
    id: 12,
    title: "The Undiscovered Self",
    author: "Carl Jung",
    date: "2020",
    rating: "10",
    topic: "Psychology",
  },
  {
    id: 13,
    title: "Man's Search For Meaning",
    author: "Viktor Frankl",
    date: "2021",
    rating: "8",
    topic: "Psychology",
  },
  {
    id: 14,
    title: "Coming To Our Senses",
    author: "Jon Kabat-Zinn",
    date: "2021",
    rating: "8",
    topic: "Psychology",
  },
  {
    id: 15,
    title: "Radical Compassion",
    author: "Tara Brach",
    date: "2021",
    rating: "7",
    topic: "Psychology",
  },

  {
    id: 17,
    title: "The Odyssey",
    author: "Homer",
    date: "2022",
    rating: "8",
    topic: "Classics",
  },
  {
    id: 18,
    title: "Advent Reflections",
    author: "Timothy Cardinal Dolan",
    date: "2022",
    rating: "7",
    topic: "Religion",
  },
  {
    id: 19,
    title: "A History of English Speaking Peoples Vols 1&2",
    author: "Winston Churchill",
    date: "2022",
    rating: "10",
    topic: "History",
  },
  {
    id: 20,
    title: "The Little Blue Book Advent",
    author: "Kenneth Edward Untener",
    date: "2022",
    rating: "9",
    topic: "Religion",
  },
  {
    id: 21,
    title: "Modern Man In Search of Soul",
    author: "Carl Jung",
    date: "2020",
    rating: "10",
    topic: "Psychology",
  },
  {
    id: 22,
    title: "Memories, Dreams, Reflections",
    author: "Carl Jung",
    date: "2020",
    rating: "10",
    topic: "Psychology",
  },
  {
    id: 23,
    title: "The Decadent Society",
    author: "Ross Douthat",
    date: "2022",
    rating: "9",
    topic: "Politics",
  },
  {
    id: 24,
    title: "A Freedom Within",
    author: "Stefan Cardinal Wyszynski",
    date: "2022",
    rating: "10",
    topic: "Religion",
  },
  {
    id: 25,
    title: "A History of English Speaking Peoples Vol 3",
    author: "Winston Churchill",
    date: "2022",
    rating: "10",
    topic: "History",
  },
  {
    id: 26,
    title: "A History Of Scotland",
    author: "J.D. Mackie",
    date: "2022",
    rating: "9",
    topic: "History",
  },
  {
    id: 27,
    title: "Lifespan",
    author: "David Sinclair",
    date: "2023",
    rating: "10",
    topic: "Biology",
  },
  {
    id: 28,
    title: "Linear Algebra A Modern Introduction",
    author: "David Poole",
    date: "2019",
    rating: "8",
    topic: "Mathematics",
  },
  {
    id: 29,
    title: "The Great Gatsby",
    author: "F. Scott Fitzgerald",
    date: "2015",
    rating: "8",
    topic: "Classics",
  },
  {
    id: 30,
    title: "The Hobbit",
    author: "J.R.R. Tolkien",
    date: "2020",
    rating: "9",
    topic: "Classics",
  },
  {
    id: 31,
    title: "Neurophilosophy",
    author: "Patricia Churchland",
    date: "2017",
    rating: "8",
    topic: "Philosophy",
  },
  {
    id: 32,
    title: "The Republic",
    author: "Plato",
    date: "2017",
    rating: "8",
    topic: "Philosophy",
  },
  {
    id: 33,
    title: "The Myth of Sisyphus",
    author: "Albert Camus",
    date: "2017",
    rating: "10",
    topic: "Philosophy",
  },
  {
    id: 34,
    title: "The Stranger",
    author: "Albert Camus",
    date: "2017",
    rating: "8",
    topic: "Philosophy",
  },
  {
    id: 35,
    title: "Nuptials",
    author: "Albert Camus",
    date: "2017",
    rating: "10",
    topic: "Philosophy",
  },
  {
    id: 36,
    title: "World Order",
    author: "Henry Kissinger",
    date: "2017",
    rating: "8",
    topic: "Politics",
  },
  {
    id: 37,
    title: "Networks, Crowds, and Markets",
    author: "David Easley",
    date: "2017",
    rating: "10",
    topic: "Computer Science",
  },
  {
    id: 38,
    title: "Common Sense on Mutual Funds",
    author: "John Bogle",
    date: "2017",
    rating: "10",
    topic: "Finance",
  },
  {
    id: 39,
    title: "The World Treasury of Physics, Astronomy, and Mathematics",
    author: "Timothy Ferris",
    date: "2017",
    rating: "10",
    topic: "Science",
  },
  {
    id: 40,
    title: "The Sun Also Rises",
    author: "Ernest Hemingway",
    date: "2017",
    rating: "9",
    topic: "Classics",
  },
  {
    id: 41,
    title: "The Language Instinct",
    author: "Steven Pinker",
    date: "2017",
    rating: "10",
    topic: "Psychology",
  },
  {
    id: 42,
    title: "Steve Jobs",
    author: "Walter Isaacson",
    date: "2017",
    rating: "10",
    topic: "Biography",
  },
  {
    id: 43,
    title: "New Products Management",
    author: "Crawford",
    date: "2019",
    rating: "8",
    topic: "Business",
  },
  {
    id: 44,
    title: "Candide",
    author: "Voltaire",
    date: "2017",
    rating: "8",
    topic: "Classics",
  },
  {
    id: 45,
    title: "The Epic of Gilgamesh",
    author: "Ancient Sumerians",
    date: "2017",
    rating: "8",
    topic: "Classics",
  },
  {
    id: 46,
    title: "Mediations",
    author: "Marcus Aurelius",
    date: "2017",
    rating: "10",
    topic: "Philosophy",
  },
  {
    id: 47,
    title: "The Genealogy of Morals",
    author: "Friedrich Nietzsche",
    date: "2017",
    rating: "8",
    topic: "Philosophy",
  },
  {
    id: 48,
    title: "Beyond Good and Evil",
    author: "Friedrich Nietzsche",
    date: "2017",
    rating: "8",
    topic: "Philosophy",
  },
  {
    id: 49,
    title: "A Brief History of Time",
    author: "Stephen Hawking",
    date: "2017",
    rating: "10",
    topic: "Science",
  },
  {
    id: 50,
    title: "Suicide of The West",
    author: "Jonah Goldberg",
    date: "2018",
    rating: "7",
    topic: "Politics",
  },
  {
    id: 51,
    title: "Scalia Speaks",
    author: "Antonin Scalia",
    date: "2019",
    rating: "9",
    topic: "Politics",
  },
  {
    id: 52,
    title: "The Point of It All",
    author: "Charles Krauthammer",
    date: "2019",
    rating: "9",
    topic: "Politics",
  },
  {
    id: 53,
    title: "Things That Matter",
    author: "Charles Krauthammer",
    date: "2019",
    rating: "9",
    topic: "Politics",
  },
  {
    id: 54,
    title: "What Kind of Creatures Are We?",
    author: "Noam Chomsky",
    date: "2017",
    rating: "9",
    topic: "Psychology",
  },
  {
    id: 55,
    title: "The Essential Dewey",
    author: "John Dewey",
    date: "2017",
    rating: "9",
    topic: "Philosophy",
  },
  {
    id: 56,
    title: "Why Nations Fail",
    author: "Daron Acemoglu",
    date: "2018",
    rating: "9",
    topic: "Economics",
  },
  {
    id: 57,
    title: "The History and Origins of Consciousness",
    author: "Erich Neumann",
    date: "2021",
    rating: "10",
    topic: "Psychology",
  },
  {
    id: 58,
    title: "The Word on Fire Bible: The Gospels",
    author: "Bishop Robert Barron",
    date: "2024",
    rating: "10",
    topic: "Religion"
  }
];

export default pastBooks;
